import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mm-pop-up',
  templateUrl: './pop-up.component.html',
  styleUrls: ['./pop-up.component.scss']
})
export class PopUpComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
